export default "__VITE_ASSET__C5zb$k8Y__"